import React from 'react';
import { string, object } from 'prop-types';
import { sizeMap } from './common';

const InputSuffixes = ({ suffixText, size, styles }) => {

  return suffixText ?
    <p key='two' className={`${sizeMap[size]} ${styles.suffixText}`}>{suffixText}</p> :
    null;
};

InputSuffixes.propTypes = {
  suffixText: string,
  size: string,
  styles: object,
};

InputSuffixes.displayName='InputSuffixes';

export default InputSuffixes;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/InputSuffixes.js